export default __webpack_public_path__ + "static/media/E09.4a0c7b63.mp3";